import { NotesService } from './BaseFramework/core/http/notes.service';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule, ApplicationRef, ErrorHandler } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { InputMaskAngularModule } from 'input-mask-angular';
import { GlobalAppRoutingModule } from './global-app-routing.module';
import { GlobalAppComponent } from './global-app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BaseframeworkModule, BaseModule } from './BaseFramework/';
import {
  LoginService,
  UserInfoService,
  ApiRequestService,
  AgentService,
  TranslateService,
  ChangePassService,
  ClientService,
  LookupDataService,
  WorkqueueService,
  InboxSortService,
  CountryCityService,
  VehicleService,


} from './BaseFramework/core/http'
import { I18nService, MultiLingualService, InteractService } from './BaseFramework/core/services'
import { ApiPrefixInterceptor, CacheInterceptor, ErrorHandlerInterceptor } from './BaseFramework/core/interceptors'
import { AppConfig, AppSettings, AppCountrySettings, AppMetadataHandler, AppOrganizationSettings } from './BaseFramework/configs'
import { AuthenticationGuard } from './BaseFramework/core/guards'
import { ClaimsAuthenticationGuard } from './ViewModules/Claims/claims-guards'
import { AuthenticationService } from './BaseFramework/core/authentication/authentication.service'
import { ValidationUtilService } from './BaseFramework/core/services/validations/validationsUtil.service'
import { FunctionalModule, PolicyIssuanceModule } from './FunctionalModules'
// import { ClaimsModule, ClaimsRoutingModule } from './ViewModules/Claims'
import { GuidGenerator, ArrayManipulations, CommonUtilty } from './BaseFramework/core/utilities'
import { IntimationService } from './BaseFramework/core/http/intimation.service';
import { InvestigationService } from './BaseFramework/core/http/investigation.service';
import { ClaimRegistrationService } from './BaseFramework/core/http/claim-registration.service';
import { GlobalErrorHandler } from "./BaseFramework/core/services/global-error-handler/global-error-handler.service";
import { RequirementService } from "./BaseFramework/core/http/requirement.service";
import { AutofocusDirective } from './ViewModules/shared-directives/autofocus/autofocus.directive';
import {DragDropModule} from '@angular/cdk/drag-drop';
import { NgZorroAntdModule } from './ng-zorro.module';
import { StoreModule } from '@ngrx/store';
import { nbuReducer } from './BaseFramework/shared/reducer/nbu.reducer';
import { globalAppReducer } from './BaseFramework/shared/models/statemodels/app-state.model';

export const interceptors = [
  { provide: HTTP_INTERCEPTORS, useClass: ApiPrefixInterceptor, multi: true }
]

export const services = [
  AuthenticationService,
  LoginService,
  UserInfoService,
  ApiRequestService,
  AppConfig,
  AppSettings,
  AgentService,
  TranslateService,
  ChangePassService,
  ValidationUtilService,
  GuidGenerator,
  AppCountrySettings,
  AppMetadataHandler,
  AppOrganizationSettings,
  ClientService,
  NotesService,
  I18nService,
  MultiLingualService,
  LookupDataService,
  WorkqueueService,
  InboxSortService,
  IntimationService,
  InvestigationService,
  ArrayManipulations,
  CommonUtilty,
  ClaimRegistrationService,
  InteractService,
  RequirementService,
  CountryCityService,
  VehicleService,
  {
    provide: ErrorHandler,
    useClass: GlobalErrorHandler
  }
]

export const guards = [
  AuthenticationGuard,
  ClaimsAuthenticationGuard
]

@NgModule({
  declarations: [
    GlobalAppComponent,
    AutofocusDirective
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    DragDropModule,
    HttpModule,
    HttpClientModule,
    FormsModule,
    NgZorroAntdModule,
    ReactiveFormsModule,
    BaseframeworkModule,
    FunctionalModule,
    NgZorroAntdModule,
    GlobalAppRoutingModule,
    InputMaskAngularModule,
    TranslateModule.forRoot({
      isolate: true
    }),
    BaseModule.forRoot(),
    PolicyIssuanceModule.forRoot(),
    StoreModule.forRoot(globalAppReducer)
  ],
  providers: [
    ...services,
    ...guards,
    ...interceptors
  ],
  exports: [BaseframeworkModule, BaseModule, TranslateModule, InputMaskAngularModule],
  bootstrap: [GlobalAppComponent]
})
export class GlobalAppModule { }
